import {isDefined} from './isDefined';

export function isObject(o?: any): o is object {
    return isDefined(o) && typeof o === 'object';
}
